<template>
  <fragment>
    <v-row dense v-if="mdAndUp">
      <template v-if="dashEventHasData">
        <v-col
          cols="12"
          sm="2"
          md="3"
          style="min-height: 80; max-height: 140px"
        >
          <v-sheet
            class="pa-3"
            v-if="dashEventLoading"
            style="min-height: 80; height: 100%; width: 100%"
          >
            <v-skeleton-loader
              type="card"
              class="rounded-xl"
              style="min-height: 50; height: 100%; width: 100%"
            >
            </v-skeleton-loader>
          </v-sheet>
          <DashCard
            v-else
            title="Faturamento Total"
            :loading="dashEventLoading"
            :percent="totalInvoincing"
          />
        </v-col>
        <v-col
          cols="12"
          sm="2"
          md="3"
          style="min-height: 80; max-height: 140px"
        >
          <v-sheet
            class="pa-3"
            v-if="dashEventLoading"
            style="min-height: 50; height: 100%; width: 100%"
          >
            <v-skeleton-loader
              type="card"
              class="rounded-xl"
              style="min-height: 50; height: 100%; width: 100%"
            >
            </v-skeleton-loader>
          </v-sheet>
          <DashCard
            v-else
            title="Ingressos Vendidos"
            :loading="dashEventLoading"
            :percent="totalSold"
          />
        </v-col>
        <v-col
          cols="12"
          sm="2"
          md="3"
          style="min-height: 80; max-height: 140px"
        >
          <v-sheet
            class="pa-3"
            v-if="dashEventLoading"
            style="min-height: 50; height: 100%; width: 100%"
          >
            <v-skeleton-loader
              type="card"
              class="rounded-xl"
              style="min-height: 50; height: 100%; width: 100%"
            >
            </v-skeleton-loader>
          </v-sheet>
          <DashCard
            v-else
            title="Ingressos Vendidos Hoje"
            :loading="dashEventLoading"
            :percent="todaySold"
          />
        </v-col>
        <v-col
          cols="12"
          sm="2"
          md="3"
          style="min-height: 80; max-height: 140px"
        >
          <v-sheet
            class="pa-3"
            v-if="dashEventLoading"
            style="min-height: 50; height: 100%; width: 100%"
          >
            <v-skeleton-loader
              type="card"
              class="rounded-xl"
              style="min-height: 50; height: 100%; width: 100%"
            >
            </v-skeleton-loader>
          </v-sheet>
          <DashCard
            v-else
            title="Percentual vendido"
            :loading="dashEventLoading"
            :percent="percentSold"
          />
        </v-col>
        <v-col
          cols="12"
          sm="4"
          md="4"
          style="min-height: 80; max-height: 140px"
        >
          <v-sheet
            class="pa-3"
            v-if="dashEventLoading"
            style="min-height: 50; height: 100%; width: 100%"
          >
            <v-skeleton-loader
              type="card"
              class="rounded-xl"
              style="min-height: 50; height: 100%; width: 100%"
            >
            </v-skeleton-loader>
          </v-sheet>
          <DashCard
            v-else
            title="Ingressos disponíveis"
            :loading="dashEventLoading"
            :percent="ableTickets"
          />
        </v-col>
        <v-col
          cols="12"
          sm="4"
          md="4"
          style="min-height: 80; max-height: 140px"
        >
          <v-sheet
            class="pa-3"
            v-if="dashEventLoading"
            style="min-height: 50; height: 100%; width: 100%"
          >
            <v-skeleton-loader
              type="card"
              class="rounded-xl"
              style="min-height: 50; height: 100%; width: 100%"
            >
            </v-skeleton-loader>
          </v-sheet>
          <DashCard
            v-else
            title="Ticket Médio"
            :loading="dashEventLoading"
            :percent="middleTicket"
          />
        </v-col>
        <v-col
          cols="12"
          sm="4"
          md="4"
          style="min-height: 80; max-height: 140px"
        >
          <v-sheet
            class="pa-3"
            v-if="dashEventLoading"
            style="min-height: 50; height: 100%; width: 100%"
          >
            <v-skeleton-loader
              type="card"
              class="rounded-xl"
              style="min-height: 50; height: 100%; width: 100%"
            >
            </v-skeleton-loader>
          </v-sheet>
          <DashCard
            v-else
            title="Cortesias"
            :loading="dashEventLoading"
            :percent="courtesy"
          />
        </v-col>
      </template>
    </v-row>
    <v-row dense v-if="!mdAndUp">
      <template v-if="dashEventHasData">
        <v-col cols="12" sm="2" md="3">
          <v-sheet
            class="pa-3"
            v-if="dashEventLoading"
            style="min-height: 80; height: 100%; width: 100%"
          >
            <v-skeleton-loader
              type="card"
              class="rounded-xl"
              style="min-height: 50; height: 100%; width: 100%"
            >
            </v-skeleton-loader>
          </v-sheet>
          <DashCardMobile
            v-else
            title="Faturamento Total"
            :loading="dashEventLoading"
            :percent="totalInvoincing"
            :percentMobile="percentMobile"
            :todayMobile="todayMobile"
            :percentsSold="percentsSold"
            :ticketsAvailable="ticketsAvailable"
            :averageTicket="averageTicket"
            :cortesyEmit="cortesyEmit"
          />
        </v-col>
      </template>
    </v-row>
  </fragment>
</template>

<script>
import { mapGetters } from "vuex";
import DashCard from "@/components/cards/DashCardEvent.vue";
import DashCardMobile from "@/components/cards/DashCardEventMobile.vue";
import { formatCurrency } from "@/utils";
import displayHelpers from "@/mixins/breakpoints.mixins";
import InfoIcon from "@/components/icons/InfoIcon.vue";
export default {
  name: "DashInfoModal",
  mixins: [displayHelpers],
  // eslint-disable-next-line vue/no-unused-components
  components: { DashCard, DashCardMobile, InfoIcon },
  data() {
    return {
      formatCurrency,
    };
  },
  computed: {
    ...mapGetters([
      "dashEvent",
      "dashEventLoading",
      "dashEventHasData",
      "checkinEvent",
      "saleTicket",
      "isOpenModal",
    ]),
    percentMobile() {
      const totalSold = Number.parseFloat(this.dashEvent.total_vendido);
      const formattedValue = Intl.NumberFormat("pt-BR").format(
        Math.abs(totalSold)
      );

      if (Math.sign(totalSold) === -1) {
        return {
          values: `-${formattedValue}`,
          class: "negative-percent",
          text: "Ingressos Vendidos",
        };
      } else {
        return {
          values: formattedValue,
          class: "positive-percent",
          text: "Ingressos Vendidos",
        };
      }
    },
    todayMobile() {
      const todaySold = Number.parseFloat(this.dashEvent.vendidos_hoje);
      const formattedValue = Intl.NumberFormat("pt-BR").format(
        Math.abs(todaySold)
      );

      if (Math.sign(todaySold) === -1) {
        return {
          values: `-${formattedValue}`,
          class: "negative-percent",
          text: "Ingressos Vendidos Hoje",
        };
      } else {
        return {
          values: formattedValue,
          class: "positive-percent",
          text: "Ingressos Vendidos Hoje",
        };
      }
    },
    percentsSold() {
      if (Math.sign(this.dashEvent.percentual) === -1) {
        return {
          values: Math.round(this.dashEvent.percentual) + "%",
          class: "negative-percent",
          text: "Percentual Vendido",
        };
      } else {
        return {
          values: Math.round(this.dashEvent.percentual) + "%",
          class: "positive-percent",
          text: "Percentual Vendido",
        };
      }
    },
    ticketsAvailable() {
      const todaySold = Number.parseFloat(this.dashEvent.ingressos_disponiveis);
      const formattedValue = Intl.NumberFormat("pt-BR").format(
        Math.abs(todaySold)
      );

      if (Math.sign(todaySold) === -1) {
        return {
          values: `-${formattedValue}`,
          class: "negative-percent",
          text: "Disponiveis",
        };
      } else {
        return {
          values: formattedValue,
          class: "positive-percent",
          text: "Disponiveis",
        };
      }
    },
    averageTicket() {
      if (Math.sign(this.dashEvent.ticket_medio) === -1) {
        return {
          values: Intl.NumberFormat("pt-BR", {
            style: "currency",
            currency: "BRL",
          }).format(Number.parseFloat(this.dashEvent.ticket_medio)),
          class: "negative-percent",
          text: "Ticket Médio",
        };
      } else {
        return {
          values: Intl.NumberFormat("pt-BR", {
            style: "currency",
            currency: "BRL",
          }).format(Number.parseFloat(this.dashEvent.ticket_medio)),
          class: "positive-percent",
          text: "Ticket Médio",
        };
      }
    },
    cortesyEmit() {
      const cortesias = Number.parseFloat(this.dashEvent.cortesias_totais);
      const formattedValue = Intl.NumberFormat("pt-BR").format(
        Math.abs(cortesias)
      );

      if (Math.sign(cortesias) === -1) {
        return {
          values: `-${formattedValue}`,
          class: "negative-percent",
          text: "Cortesias",
        };
      } else {
        return {
          values: formattedValue,
          class: "positive-percent",
          text: "Cortesias",
        };
      }
    },
    totalInvoincing() {
      if (Math.sign(this.dashEvent.faturamento_total) === -1) {
        return {
          value: Intl.NumberFormat("pt-BR", {
            style: "currency",
            currency: "BRL",
          }).format(Number.parseFloat(this.dashEvent.faturamento_total)),
          class: "negative-percent",
        };
      } else {
        return {
          value: Intl.NumberFormat("pt-BR", {
            style: "currency",
            currency: "BRL",
          }).format(Number.parseFloat(this.dashEvent.faturamento_total)),
          class: "positive-percent",
        };
      }
    },
    middleTicket() {
      if (Math.sign(this.dashEvent.ticket_medio) === -1) {
        return {
          value: Intl.NumberFormat("pt-BR", {
            style: "currency",
            currency: "BRL",
          }).format(Number.parseFloat(this.dashEvent.ticket_medio)),
          class: "negative-percent",
        };
      } else {
        return {
          value: Intl.NumberFormat("pt-BR", {
            style: "currency",
            currency: "BRL",
          }).format(Number.parseFloat(this.dashEvent.ticket_medio)),
          class: "positive-percent",
        };
      }
    },
    totalSold() {
      const totalSold = Number.parseFloat(this.dashEvent.total_vendido);
      const formattedValue = Intl.NumberFormat("pt-BR").format(
        Math.abs(totalSold)
      );

      if (Math.sign(totalSold) === -1) {
        return {
          value: `-${formattedValue}`,
          class: "negative-percent",
        };
      } else {
        return {
          value: formattedValue,
          class: "positive-percent",
        };
      }
    },
    todaySold() {
      const cortesiasTotais = Number.parseFloat(this.dashEvent.vendidos_hoje);
      const formattedValue = Intl.NumberFormat("pt-BR").format(
        Math.abs(cortesiasTotais)
      );

      if (Math.sign(cortesiasTotais) === -1) {
        return {
          value: `-${formattedValue}`,
          class: "negative-percent",
        };
      } else {
        return {
          value: formattedValue,
          class: "positive-percent",
        };
      }
    },
    courtesy() {
      const cortesiasTotais = Number.parseFloat(
        this.dashEvent.cortesias_totais
      );
      const formattedValue = Intl.NumberFormat("pt-BR").format(
        Math.abs(cortesiasTotais)
      );

      if (Math.sign(cortesiasTotais) === -1) {
        return {
          value: `-${formattedValue}`,
          class: "negative-percent",
        };
      } else {
        return {
          value: formattedValue,
          class: "positive-percent",
        };
      }
    },
    ableTickets() {
      const disponiveis = Number.parseFloat(
        this.dashEvent.ingressos_disponiveis
      );
      const formattedValue = Intl.NumberFormat("pt-BR").format(
        Math.abs(disponiveis)
      );

      if (Math.sign(disponiveis) === -1) {
        return {
          value: `-${formattedValue}`,
          class: "negative-percent",
        };
      } else {
        return {
          value: formattedValue,
          class: "positive-percent",
        };
      }
    },
    percentSold() {
      if (Math.sign(this.dashEvent.percentual) === -1) {
        return {
          value: Math.round(this.dashEvent.percentual) + "%",
          class: "negative-percent",
        };
      } else {
        return {
          value: Math.round(this.dashEvent.percentual) + "%",
          class: "positive-percent",
        };
      }
    },
  },
};
</script>

<style scoped>
.tooltip-msg {
  display: flex !important;
  position: relative !important;
  z-index: 999999 !important;
  top: -88px !important;
  left: 295px !important;
}
</style>
